module.exports = __webpack_public_path__ + "static/media/swiss_online_garantie.b1b237ec.svg";